import { ButtonGroup, Row, DialogCardBody, DialogCardFooter, ButtonText, Col, Icon } from "@visa/vds"
import React from "react"
import NumberedCircle from "../../../components/gettingstarted/NumberedCircle"
import AnsweredRow from "./AnsweredRow"

const QuestionDialog = (props) => {

    const {
        answers,
        handleCheckImplementationType,
        setAnswers,
        setQuestionNumber,
        questionNumber,
        questionnaire
    } = props
    return (
        <>
            <DialogCardBody className="getting-started-dialog-body">
                {questionnaire && questionnaire.map((question, questionId) => (
                    <Row className="getting-started-question-set">
                        {
                            // current
                            (questionId + 1 === questionNumber) ?
                                (
                                    <>
                                        <Row>
                                            <NumberedCircle background="#1434CB" textColor="white" number={questionId + 1} />
                                            <span className="getting-started-current-question-text-mobile">{question.question}</span>
                                            <span className="getting-started-current-question-text">{question.question}</span>
                                        </Row>
                                        <Row>
                                            {question.answers.map((ans, id) => (
                                                <Row
                                                    className="display-flex align-items-flex-start padding-top-8px"
                                                    onClick={() => {
                                                        const newAns = { ...answers }
                                                        newAns[questionNumber] = parseInt(ans.value)
                                                        setAnswers(newAns)
                                                        if (questionNumber < 4) {
                                                            setQuestionNumber(questionNumber + 1)
                                                        } else {
                                                            handleCheckImplementationType(newAns)
                                                        }
                                                    }
                                                    }
                                                    id={`getting-started-question-${questionNumber}-choice-${id}`}
                                                    key={`getting-started-question-${questionNumber}-choice-${id}`}>
                                                    <Col className="display-flex">
                                                        <Icon
                                                            className="padding-left-35px getting-started-circle-icon vss-clickable-icon"
                                                            name="circle-empty"
                                                            resolution="tiny"
                                                            aria-label="circle empty" />
                                                    </Col>
                                                    <Col>
                                                        <span className="getting-started-current-question-text-answer">{ans.label}</span>
                                                        <span className="getting-started-current-question-text-answer-mobile">{ans.label}</span>
                                                    </Col>
                                                </Row>
                                            ))}
                                        </Row>
                                    </>
                                )
                                // answered
                                : (questionId + 1 < questionNumber) ? (
                                    <AnsweredRow answer={question.answers.find(ans => ans.value === answers[questionId + 1])} question={question} questionId={questionId} />
                                )
                                    // unanswered
                                    : (
                                        <Row>
                                            <NumberedCircle background="#8F8F8F" textColor="white" number={questionId + 1} />
                                            <span className="getting-started-unanswered-question-text-mobile">{question.question}</span>
                                            <span className="getting-started-unanswered-question-text">{question.question}</span>
                                        </Row>
                                    )
                        }
                    </Row>
                ))}
            </DialogCardBody >
            <DialogCardFooter>
                <ButtonGroup direction="right">
                    {questionNumber > 1 &&
                        <ButtonText className="getting-started-button"
                            colorScheme="secondary"
                            id="dialog-accept-button"
                            onClick={() => setQuestionNumber(questionNumber - 1)}
                        >
                            Previous
                        </ButtonText>}
                </ButtonGroup>
            </DialogCardFooter>
        </>
    )
}

export default QuestionDialog